// SAR - Saudi Riyal
export { default as SAFlag } from './SAFlag'
// USD - US Dollar
export { default as USFlag } from './USFlag'
// INR - Indian Rupee
export { default as INFlag } from './INFlag'
// EUR - Euro
export { default as EURFlag } from './EURFlag'
// AED - UAE Dirham
export { default as AEDFlag } from './AEDFlag'
// BHD - Bahraini Dinar
export { default as BHDFlag } from './BHDFlag'
// GBP - British Pound
export { default as GBPFlag } from './GBPFlag'
// KWD - Kuwaiti Dinar
export { default as KWDFlag } from './KWDFlag'
// QAR - Qatari Riyal
export { default as QARFlag } from './QARFlag'
// OMR - Omani Rial
export { default as OMRFlag } from './OMRFlag'
// EGP - Egyptian Pound
export { default as EGFlag } from './EGFlag'
